export default ([
  {
    questionId: 'question_one',
    visibility: {}
  },
  {
    questionId: 'question_two',
    visibility: {
      answer: {
        id: 'qid_voip_user',
        type: 'include',
        value: 'option'
      }
    }
  },
  {
    questionId: 'question_three',
    visibility: {
      answer: {
        id: 'qid_voip_user',
        type: 'exclude',
        value: 'option'
      }
    }
  },
  {
    questionId: 'question_four',
    visibility: {}
  }
])
